<template>
	<div id="voucherList" class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">	
			<el-form label-width="90px" inline label-position="left">
				<el-form-item label="凭证汇总表">
					<accounting-period @defaultTime='defaultTime'></accounting-period>
				</el-form-item>
				<el-form-item label="科目级次" >
					<el-select  size="mini" style="width: 120px" v-model='form.level'>
						<el-option v-for='item in options' :label='item.label' :value='item.value' :key='item.value'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" class='minButton' @click='getTableList'>搜索</el-button>
				</el-form-item>

				<el-form-item class="right-position">
					<el-dropdown size="mini">
						<el-button size="mini" class='minButton'>
							打印 <i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="handlePrint('transverse')">横向</el-dropdown-item>
							<el-dropdown-item @click.native="handlePrint('')">纵向</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-form-item>
			</el-form>
		</div>
		<!-- 公共table 样式 -->
		<public-table  :table="tableData">
		</public-table>
	</div>
</template>

<script>
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	
export default {
	data(){
		return {
			isFirstActive: false,
			form: {
				start: '',
				end: '',
				level: 1
			},
			options: [{
					value: 1,
					label: '一级'
				},{
					value: 2,
					label: '二级'
				},{
					value: 3,
					label: '三级'
				},{
					value: 4,
					label: '四级'
				},{
					value: 5,
					label: '五级'
				}],
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '科目编码',
					value: 'code',
					show: 'normal'
				},{
					label: '科目名称',
					value: 'name',
					show: 'normal'
				},{
					label: '借方金额',
					value: 'debitMoney',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '贷方金额',
					value: 'creditorMoney',
					show: 'normal',
					formatter: this.formatter
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			},
		}
	},
	components:{
		publicTable,
		accountingPeriod
	},
	created(){
		this.init();
	},
	computed: {
	
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		}
	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.getTableList();
		}
		this.isFirstActive = true;
	},
	methods:{
		init(){
			//快速访问
			
		},
		// 表格格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'debitMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'creditorMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
			}
		},
		// 打印功能块
		handlePrint(data) {
			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				direction: data,
				start: this.$util.formatDate.format(this.form.start , 'yyyyMM'),
				end: this.$util.formatDate.format(this.form.end , 'yyyyMM'),
				level: this.form.level

			}
			const router = this.$router.resolve({
				path: '/createPDF/printVoucherGather',
				query: params
			})

			window.open(this.$rootUrl + router.href, '_blank');
		},
		// 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				start: data.yearPeriodsStart,
				end:  data.yearPeriodsEnd,
			})
			this.getTableList();
		},
		// 获取表格
		getTableList() {
			let parms = {
				start: this.$util.formatDate.format(this.form.start , 'yyyyMM'),
				end: this.$util.formatDate.format(this.form.end , 'yyyyMM'),
				level: this.form.level
			}
			try {
				this.tableData.loading = true;
				this.$http.post('voucherChief/findVoucherGatherData' , parms).then(res=>{
					this.tableData.loading = false;
					if(res) {
						this.tableData.data = res.data.data;
					}
				})
			}catch(e) {
				this.tableData.loading = false;
			}
		},
	},
	mounted() {
		
	},
}
</script>

<style lang="less" scoped>
	#voucherList{
		
	}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/voucherList.vue